/*=====================================
    ForgetPwdDialog

    Author: Ac
    CreateTime: 2018 / 08 / 17
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle, Colors, DialogStyle } from 'stylecomponents';
import GLOBAL from 'nonnglobal';
/*--------------------------
    Styled
--------------------------*/
const Title = styled.div`
    font-size: 23px;
    color: #4A4A4A;
    font-weight: 600;
    text-align: center;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #D9D9D9;
`;
const RowTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #232423;
    margin-bottom: 10px;
`;
const Input = GlobalStyle.BasicInput.extend`
`;
const SignInBtn = styled.div`
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 2px;
    background-color: ${Colors.MAIN_COLOR};
    color: #FFF;
    font-size: 16px;
    margin: 17px 0 16px;
    cursor: pointer;
    opacity: ${({ disable }) => disable ? 0.5 : 1};
`;
const SignUpGuide = styled.div`
    text-align: center;
    font-size: 14px;
    color: #4A4A4A;
`;
/*--------------------------
    Main Component
--------------------------*/
class ForgetPwdDialog extends Component {

    constructor(props) {

        super(props);

        this.state = {
            email: '',
            isLoading: false,
        };
    }

    componentDidMount (){
        window.addEventListener('keydown', this.onKeydown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown = ({ keyCode }) => {
        if(keyCode === 27) 
            this.hideDialog();
        else if(keyCode === 13)
            this.sendVerifyMail();
    }
    
    hideDialog = () => {
        this.props.webActions.closeForgetPwdDialog();
    }

    handleEmailChange = event => {
        this.setState({ email: event.target.value });
    }

    sendVerifyMail = () => {

        if(this.state.isLoading) return;

        if(GLOBAL.isEmpty(this.state.email)){
            this.props.webActions.openAlertDialog({                    
                title: '請輸入電子郵件信箱',
                closeName: '確定',
                closeCallback: () => {
                    this.emailInput && this.emailInput.focus();
                }
            });
            return;
        }
        this.setState({ isLoading: true }, () => {
            this.props.memberActions.forgetPassword({ email : this.state.email }).then(
                (result) => {
                    this.setState({ isLoading: false }, () => {
                        if(result) {
                            this.props.webActions.openAlertDialog({
                                title: '重設密碼申請成功',
                                description: '密碼重設定信件已寄出，請儘速至您的信箱確認。',
                                closeCallback: () => {
                                    this.hideDialog();
                                }
                            })
                        }
                    });
                },(error) =>{
                    this.setState({
                        isLoading: false,
                        isError: true,
                    }, () => {
                        if(error && error.code) {
                            var errorMsg = '';
                            switch(error.code) {
                                case 'error.account.accountNotExist':
                                    errorMsg = "此帳號不存在";
                                    break;
                                default:
                                    errorMsg = error.message;
                                    break;
                            }
                            this.props.webActions.openAlertDialog({                    
                                title: '錯誤訊息',
                                description : errorMsg,
                                closeName: '確定',
                                closeCallback: () => {
                                    this.emailInput && this.emailInput.focus();
                                }
                            });
                        }
                    });
                }
            );
        });
    }
    
    render() {

        let {
            email = '',
            isLoading,
        } = this.state;

        return (
            <DialogStyle.Content
                // style props
                maxWidth="350px"
                margin="200px auto auto auto"
                padding="30px"
                borderRadius="3px"
                // dialog props
                visible
                animation="zoom"
                maskAnimation="fade"
                closable={false}
                className="signup-modal"
                onClose={this.hideDialog}
            >
                <DialogStyle.CloseButton onClick={this.hideDialog}>
                    <i className="zmdi zmdi-close"></i>
                </DialogStyle.CloseButton>
                <Title>忘記密碼</Title>
                <RowTitle>電子信箱</RowTitle>
                <Input
                    innerRef={ref => this.emailInput = ref}
                    type='text'
                    placeholder='請輸入電子信箱'
                    value={email}
                    onChange={this.handleEmailChange}
                />
                <SignInBtn onClick={this.sendVerifyMail} disable={isLoading || !email.trim()}>
                    寄送重設密碼信件
                </SignInBtn>
                <SignUpGuide>
                    輸入登入使用的信箱，系統將會發送一封密碼重設定信件，幫助您重新設定您的密碼！
                </SignUpGuide>
            </DialogStyle.Content>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(ForgetPwdDialog);